import React, { Component } from 'react';
import PresetBox from './Components/PresetBox';
import './PresetScroll.css'
import Config from './Configs/criteria.json';

const NUM_OF_PRESET = 6;
const NUM_OF_PRESET_DISPLAY = 4;
const PRESETBOX_WIDTH = 238;
const ARROW_WIDTH = 22;
export default class PresetScroll extends Component {
    // constructor(props) {
    //     super(props);
    //     // this.scrollRef = React.createRef();
    // }
    handleLeftArrow = () => {
        if (this.props.leftArrowSelected) {
            let scrollXPos = this.props.scrollXPos;
            // if (scrollXPos+PRESETBOX_WIDTH-ARROW_WIDTH === 0) {
            scrollXPos += PRESETBOX_WIDTH * 2 - ARROW_WIDTH;
            // } else {
            // scrollXPos += PRESETBOX_WIDTH;
            // }
            this.props.onScrollXPosChange(scrollXPos);
            this.props.handleArrowSelected(false);
            // this.setState({ leftArrowSelected: false });
        }
    }
    handleRightArrow = () => {
        if (!this.props.leftArrowSelected) {
            let scrollXPos = this.props.scrollXPos;
            // if (scrollXPos === 0) {
            scrollXPos -= PRESETBOX_WIDTH * 2 - ARROW_WIDTH;
            // } else {
            // scrollXPos -= PRESETBOX_WIDTH;
            // }
            this.props.onScrollXPosChange(scrollXPos);
            this.props.handleArrowSelected(true);
            // this.setState({ leftArrowSelected: true });
        }
    }
    handleLoadPreset = (num) => (e) => {
        this.props.onLoadPreset(num);
    }
    handleLoadCustom = (num) => (e) => {
        this.props.onLoadCustom(num);
    }
    genCustomPresetBox = () => {
        let result = [];
        for (let i = 0; i < Config.myscreener.maxnum; i++) {
            result.push(<PresetBox key={i} id={"0" + (i + 1)} name={this.props.data[i].name} empty={this.props.data[i].name === ""} type="custom" data={this.props.data[i]} data2={this.props.data2[i]} onLoadCustom={this.handleLoadCustom(i)} presetSelected={this.props.presetSelected} clearAll={this.props.clearAll} />)
        }
        return result;
    }
    genPresetBox = () => {
        let result = [];
        for (let i = 0; i < Config.presetscreener.maxnum; i++) {
            result.push(<PresetBox key={i} id={"0" + (i + 1)} name={this.props.preset[i].name} description={this.props.preset[i].description} count={this.props.preset[i].count} onLoadPreset={this.handleLoadPreset(i)} presetSelected={this.props.presetSelected} clearAll={this.props.clearAll} />)
        }
        return result;
    }
    render() {
        return (
            <div className="PresetScroll">
                <div className={this.props.leftArrowSelected?"leftarrow arrowSelected":"leftarrow"} onClick={this.handleLeftArrow}>
                    <svg id="more-arrows" width="9" height="24" viewBox="0 0 9 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M7.5 22L2 12.1984L7.5 2" stroke={this.props.leftArrowSelected?"#FFFFFF":"#B6B9BF"} stroke-width="2" stroke-linecap="square" />
                    </svg>
                </div>
                <div className="divcontainer">
                    <div className="container" style={{ transform: 'translateX(' + this.props.scrollXPos + 'px)' }}>
                        {this.props.section === "preset" &&
                            this.genPresetBox()
                        }
                        {this.props.section === "custom" &&
                            this.genCustomPresetBox()
                        }
                        <div style={{ clear: "both" }} />
                    </div>
                </div>

                <div className={!this.props.leftArrowSelected?"rightarrow arrowSelected":"rightarrow"} onClick={this.handleRightArrow}>
                    <svg id="more-arrows" width="9" height="24" viewBox="0 0 9 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M2 2L7.5 11.8016L2 22" stroke={!this.props.leftArrowSelected?"#FFFFFF":"#B6B9BF"} stroke-opacity="1" stroke-width="2" stroke-linecap="square" />
                    </svg>
                </div>
            </div>
        )
    }
}